import { useMutation, useQueryClient } from "react-query";

import { crearMaquina, updateMaquina, deleteMaquina} from '../../services/Maquinas';

import { toast } from 'react-hot-toast';
const queryKey = "maquinas";

export const useMaquinasMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addMaquina = useMutation((body) => crearMaquina(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
 
  const updateMaquinaC = useMutation(
    (body) => updateMaquina( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeMaquina = useMutation((id) => deleteMaquina( id), {
    onSuccess,
    onError,
  });

  return { addMaquina, updateMaquinaC, removeMaquina };
};
export default useMaquinasMutations;